import { Plane, BookUser as Passport, Wallet, CloudSun, Shirt, Signal, HandCoins, Car } from "lucide-react";
import SectionTitle from "../components/SectionTitle";

const items = [
  {
    icon: Plane,
    t: "Airports",
    body: (
      <>
        <p><b>POP — Puerto Plata</b> (~30 min): closest, easiest. Aim for this one.</p>
        <p><b>STI — Santiago</b> (1.5 hr): backup if POP flights don't work.</p>
        <p><b>SDQ — Santo Domingo</b> (4 hr): not recommended.</p>
      </>
    ),
  },
  {
    icon: Passport,
    t: "Passport",
    body: <p>US citizens don't need a visa. Your passport <b>must be valid 6 months past the travel date</b> — check today if you haven't in a while.</p>,
  },
  {
    icon: Car,
    t: "Transfers",
    body: <p>Villa Taina arranges airport pickups (~$70 each way). Ubers are also readily available at the airport. Rental cars are optional — you won't need one in town but it's nice if you want to day-trip to Playa Grande.</p>,
  },
  {
    icon: CloudSun,
    t: "Weather",
    body: <p>Mid-May: ~85°F, low humidity, occasional 20-minute afternoon showers that clear fast. Bring one light layer for evenings.</p>,
  },
  {
    icon: Shirt,
    t: "Packing",
    body: (
      <ul className="list-disc list-inside space-y-1">
        <li>Swimsuits</li>
        <li>Sunscreen</li>
        <li>Light layers for the evening</li>
        <li>Sunglasses, hat, flops</li>
        <li>You're an adult, figure it out</li>
      </ul>
    ),
  },
  {
    icon: Wallet,
    t: "Currency",
    body: <p>Dominican Peso. USD widely accepted. Small bills help for tipping.</p>,
  },
  {
    icon: Signal,
    t: "Cell service",
    body: <p>Most US carriers work. eSIMs are cheap (Airalo, Holafly) if you'd rather not roam.</p>,
  },
  {
    icon: HandCoins,
    t: "Tipping",
    body: <p>~10% at restaurants (check if service is already included), $1-2/bag for bellhops, $5/day for housekeeping.</p>,
  },
];

export default function Travel() {
  return (
    <div className="bg-cream">
      <section className="pt-20 pb-10 md:pt-28 md:pb-14 relative overflow-hidden" data-testid="travel-hero">
        <div className="absolute inset-0 hero-glow pointer-events-none" />
        <div className="max-w-6xl mx-auto px-6 md:px-10 relative">
          <p className="text-xs tracking-[0.4em] uppercase text-terracotta font-medium mb-4">Travel & Logistics</p>
          <h1 className="font-display text-6xl md:text-8xl font-black text-ink leading-[0.9]">
            Getting <span className="italic text-sage-dark">there.</span>
          </h1>
          <p className="text-lg text-muted_ink mt-5 max-w-2xl">
            Everything you need to book flights, pack a bag, and not stress on the way.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-5">
          {items.map((it, i) => (
            <div key={it.t} className="bg-sand border border-shell rounded-lg p-6 md:p-8" data-testid={`travel-${i}`}>
              <it.icon className="w-6 h-6 text-terracotta mb-4" />
              <h3 className="font-display text-2xl font-black text-ink mb-3">{it.t}</h3>
              <div className="text-muted_ink text-base leading-relaxed space-y-2">{it.body}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
